import { render, staticRenderFns } from "./MyPerPageSelector.vue?vue&type=template&id=38b212f6&"
import script from "./MyPerPageSelector.vue?vue&type=script&lang=js&"
export * from "./MyPerPageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports